import React from 'react';

const SettingsFormGroup = ({ children, className, sx, style }) => (
  <div 
    className={`${className} settings-form__form-group`} 
    style={{ 
      margin: 0,
      padding: 0,
      width: '100%',
      ...style 
    }}
  >
    {children}
  </div>
);

export default SettingsFormGroup;
